module.exports = __webpack_public_path__ + "img/punt_left.2f14aaa9.jpg";